import safeToFixer from './safeToFixer';

// 小数第${decimalPlaceNum}位までで四捨五入して、xとyが等しいかどうか
export default function isDecimalEqual(x, y, decimalPlaceNum = 0) {
  const [fixedX, fixedY] = [x, y].map(num => safeToFixer(num, decimalPlaceNum));

  if (fixedX === '' || fixedY === '') {
    return false;
  }

  return fixedX === fixedY;
}



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/utils/isDecimalEqual.js